import React from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import Svg, { Line } from 'react-native-svg';

import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { AppColors } from '@/components/lib/theme';
import { designSystem } from '@/styles/styles';

const PADDING = 16;

export const LabelDividerRow = ({
    leftText,
    rightText,
    dashLength = 4,
    gap = 4,
    height = 2,
    textStyle,
}: {
    leftText: string;
    rightText?: string;
    dashLength?: number;
    gap?: number;
    height?: number;
    textStyle?: {
        backgroundColor: AppColors;
        color: AppColors;
    };
}) => {
    const { width: screenWidth } = useWindowDimensions();
    const containerWidth = screenWidth - 2 * PADDING;
    const dashCount = Math.floor(containerWidth / (dashLength + gap));

    return (
        <Box paddingVertical={'s8'} position={'relative'} width={'100%'}>
            <Svg
                style={[StyleSheet.absoluteFill, { transform: [{ translateY: PADDING + height }] }]}
                height={height}
                width={'100%'}
            >
                {Array.from({ length: dashCount }).map((_, i) => {
                    const x = i * (dashLength + gap);
                    return (
                        <Line
                            key={i}
                            x1={x}
                            y1={height / 2}
                            x2={x + dashLength}
                            y2={height / 2}
                            stroke={designSystem.colors.neutral600}
                            strokeWidth={1}
                        />
                    );
                })}
            </Svg>

            <Row justifyContent={'space-between'}>
                <Box
                    backgroundColor={textStyle?.backgroundColor ?? ds.colorToken.background.neutral.subtler}
                    paddingRight={'s8'}
                >
                    <Text variant={'bodySmall'} color={textStyle?.color ?? 'neutral300'}>
                        {leftText}
                    </Text>
                </Box>

                {rightText ? (
                    <Box
                        backgroundColor={textStyle?.backgroundColor ?? ds.colorToken.background.neutral.subtler}
                        paddingLeft={'s8'}
                    >
                        <Text variant={'bodySmall'} color={textStyle?.color ?? 'neutral300'}>
                            {rightText}
                        </Text>
                    </Box>
                ) : null}
            </Row>
        </Box>
    );
};
